export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="32" fill="#181203" />
    <path d="M32 28c-1-8 2-14 7-18-1 8-3 14-7 18z" fill="#4CAF50" />
    <path d="M32 28c1-8-2-14-7-18 1 8 3 14 7 18z" fill="#66BB6A" />
    <path d="M32 27c-4-6-10-9-16-9 5 5 10 8 16 9z" fill="#2E7D32" />
    <path d="M32 27c4-6 10-9 16-9-5 5-10 8-16 9z" fill="#2E7D32" />
    <defs>
      <clipPath id="pj"><ellipse cx="32" cy="42" rx="11.5" ry="14.5" /></clipPath>
    </defs>
    <ellipse cx="32" cy="42" rx="11.5" ry="14.5" fill="#FFD000" />
    <g clipPath="url(#pj)" stroke="#D49808" strokeWidth="1.5" fill="none">
      <path d="M18 34l22 24M25 31l22 24M32 28l22 24M46 34L24 58M39 31L17 55M32 28L10 52" />
    </g>
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-[#FFD000]" : "text-[#181203]"}`}>
      sweet<span className="font-serif-i font-normal">juice</span>
    </span>
  </span>
);
